import { getLocale } from '@/utils/get-locale-util';

export const NUVEI_SDK_URL = 'https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js';

export const NUVEI_FIELD_IDS = {
  CARD_NUMBER: 'nuvei-card-number',
  EXPIRATION: 'nuvei-card-expiry',
  CVC: 'nuvei-card-cvc',
} as const;

export const NUVEI_FIELD_STYLES = {
  base: {
    fontSize: '16px',
    color: 'inherit',
    lineHeight: '100%',
    padding: '0',
    '::placeholder': {
      color: 'rgb(156, 163, 175)',
    },
  },
  'sfc-empty': {
    '::placeholder': {
      color: 'rgb(156, 163, 175)',
      opacity: '1',
    },
  },
  empty: {
    color: 'inherit',
    '::placeholder': {
      color: 'rgb(156, 163, 175)',
      opacity: '1',
    },
  },
  valid: {
    color: 'inherit',
  },
  invalid: {
    color: 'inherit',
  },
} as const;

export const getNuveiLocale = (): string => {
  const { pspLocale } = getLocale();
  return pspLocale;
};
